<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { interactionMixin } from 'src/modules/interactions_module.js';
import StripeHeader from "stripe-header";

export default {
  components: {
    StripeHeader
  },
  mixins: [fandomBasicMixin, interactionMixin],
  methods: {
    downloadInteractionHandler(interaction, attachment) {
      if (!!interaction && !!attachment && !!attachment.url) {
        this.updateDownloadInteraction(this.containerContent, this.content, interaction, null, attachment.url);
      }
    },
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser()"
    :class="contentType"
    class="pt-4 pb-5"
    :style="{'background-color': (content.background_color || 'inherit')}"
    list-keypoints-v4-component
  >
    <stripe-header :content="content" align="center"></stripe-header>
    <div class="container-fluid px-md-5 ">
      <div
        v-for="(row, index) in content.rows"
        :key="`row-${index}`"
        :class="{'dashed-border': row.dashed_top_separator}"
        class="w-100 py-4 keypoint-row d-flex flex-column flex-md-row justify-content-between align-items-center"
      >
        <div class="row-heading pb-4 pb-md-0">
          <div class="h3 text-uppercase mb-2">{{row.title}}</div>
          <p v-html="row.description" class="text-gray-800 mb-0"></p>
        </div>
        <div class="d-flex flex-wrap justify-content-center justify-content-md-end">
          <div
            v-for="(keypoint, i) in row.keypoints"
            class="text-center py-2 px-3 number-keypoint"
            :class="{'cursor-pointer': !!keypoint.attachment}"
            @click="downloadInteractionHandler(keypoint.interaction, keypoint.attachment)"
          >
            <div class="h1 mb-2" :style="{'color': (keypoint.number_color || '#202020')}">{{keypoint.number}}</div>
            <p v-html="keypoint.description" class="text-gray-800 mb-0"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[list-keypoints-v4-component] {
  .keypoint-row {
    border-top: 1px solid $gray-500;

    &.dashed-border {
      border-top: 1px dashed $gray-500;
    }

    &:last-child {
      border-bottom: 1px solid $gray-500;
    }
  }

  .row-heading {
    min-width: 10rem;
  }

  .number-keypoint {
    max-width: 8rem;
  }

  @include media-breakpoint-down(sm) {
    .row-heading {
      text-align: center;
    }
  }
}
</style>